<template>
    <div class="assignments-in-progress apprentice-simple-card ">
        <div class="component-title">
            <h5 class="title">
                {{ header }}
            </h5>
        </div>

        <div class="portfolio-item" v-for="(item) in assignments" :key="item.id"
             @click="showAssignment(item.id, projectId)" v-if="assignments.length">
            <div class="content">
                <h5 class="assignment-title">
                    {{item.name}}
                    <div class="status">
                        <b-badge :variant="'primary'" pill v-if="hasRatingResult(item)"
                                 class="badge-rating">
                            <i class="fas fa-fw fa-trophy"></i>{{getRatingValue(item)}}
                        </b-badge>
                        <div class="timestamp text-muted" v-if="item.deadline">
                            {{item.deadline.date_time | date_named_month}}
                        </div>
                    </div>
                </h5>

                <div class="badges assignment-badges"
                     v-if="item.assignment_tags?.length">
                    <b-badge pill
                             :style="cssTagColor(tag.color)"
                             v-for="tag of item.assignment_tags"
                             :key="`${tag.name}-${tag.id}`">
                        {{ tag.name }}
                    </b-badge>
                </div>

                <div v-if="inProgress">{{item.category}}</div>
            </div>
            <div class="progressbar">
                <b-progress :max="item.progress_status.total" show-value>
                    <b-progress-bar :value="item.progress_status.closed" variant="success"
                                    v-b-tooltip.hover
                                    :title="`${item.progress_status.closed} Afgerond`"></b-progress-bar>
                    <b-progress-bar :value="item.progress_status.submitted" variant="warning"
                                    v-b-tooltip.hover
                                    :title="`${item.progress_status.submitted} Ingeleverd`"></b-progress-bar>
                    <b-progress-bar :value="item.progress_status.reopened" variant="danger"
                                    v-b-tooltip.hover
                                    :title="`${item.progress_status.reopened} Afgekeurd / Opnieuw`"></b-progress-bar>
                    <b-progress-bar :value="item.progress_status.open" variant="open"
                                    v-b-tooltip.hover
                                    :title="`${item.progress_status.open} Open`"></b-progress-bar>

                </b-progress>
                <span class="completed">
                    {{completion(item.progress_status)}}% {{$t('portfolio.completed')}}
                </span>
            </div>
        </div>

        <div class="not-found with-header empty-assignments-list" v-if="!(assignments.length)">
            <div class="icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="alert-notice">{{$t('portfolio.you_do_not_have_an_assignment_in_progress')}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "design-2021-portfolio-show-assignments-card-component",
        props: ['headerNameIn', 'items', 'projectId', 'inProgress'],
        data() {
            return {
                header: (this.headerNameIn) ? this.headerNameIn : null,
                assignments: this.items,
            }
        },
        methods: {
            completion(progress) {
                if(parseInt(progress.closed) !== 0 || parseInt(progress.submitted) !== 0 && parseInt(progress.total) !==
                    0) {
                    return ((progress.closed + progress.submitted) / progress.total * 100).toFixed(0);
                }
                return 0;
            },

            showAssignment(assignmentId, projectId) {
                window.location.href = this.routes.assignmentShow(assignmentId, projectId);
            },

            hasRatingResult(assignment) {
                return assignment.portfolio_rating && assignment.portfolio_rating.results.length;
            },

            getRatingValue(assignmentData) {
                if(assignmentData.portfolio_rating.type === 1){
                    for(const option of assignmentData.portfolio_rating.options){
                        if(assignmentData.portfolio_rating.results[0].portfolio_rating_option_id === option.id){
                            return option.value;
                        }
                    }
                }

                if(assignmentData.portfolio_rating.type === 2){
                    return assignmentData.portfolio_rating.results[0].value;
                }
            },

            cssTagColor(color) {
                return {
                    '--tagColor': color,
                }
            }
        },
         created() {
            if(this.inProgress && this.items.length) {
                this.assignments = this.items.filter(assignment => {
                    if(this.completion(assignment.progress_status) !== 100) {
                        return assignment;
                    }
                })
            }
         },
         watch: {
           items: function (value) {
               this.assignments = value;
           }
         },
    }
</script>

<style scoped lang="scss">
    .assignments-in-progress {
        min-height: 230px;

        .not-found {
            margin-bottom: 45px;
        }
    }

    .portfolio-item {

        .content {
            margin-bottom: map-get($grid-gutter-spacing, 'ten');
            padding: map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'fifteen') 0 map-get($grid-gutter-spacing, 'fifteen');
        }

        .assignment-title {
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            font-weight: $font-weight-bold;
            line-height: 1;
            font-size: $base-font-size;
            margin-bottom: map-get($grid-gutter-spacing, 'eight');

            .status {
                display: flex;
                align-items: baseline;
                flex-wrap: wrap;
                justify-content: flex-end;
                width: auto;
                margin-top: map-get($grid-gutter-spacing, 'five');
                margin-left: map-get($grid-gutter-spacing, 'fifteen');
                align-self: flex-end;

                .badge-rating {
                    align-self: flex-end;
                }

                .timestamp {
                    font-weight: $font-weight-bold;
                    align-self: center;
                    line-height: 1.3;

                    &:is(:nth-child(2)){
                        margin-left: map-get($grid-gutter-spacing, 'fifteen');
                    }
                }
            }
        }

        .progressbar ::v-deep {
            display: flex;
            align-items: baseline;
            justify-content: flex-end;
            flex-wrap: wrap;
            padding:  0 map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'fifteen');

            .progress {
                height: 12px;
                background-color: darken($border-color, 56%);
                width: 100%;
                margin-bottom: 5px;
                border-radius: 4px;
            }

            .progress,
            .progress .progress-bar {
                border-radius: 0;
            }

            .completed {
                color: $text-color;
                font-size: 0.875rem;
            }
        }

        &:not(:last-child) {
            border-bottom: 3px dotted $border-color;
            padding-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }

        &:hover,
        &:nth-child(odd):hover {
            cursor: pointer;
            background-color: $secondary-background-color;
            border-radius: $border-radius-content;
        }
    }

    @media (min-width: map-get($grid-breakpoints, 'sm')) {
        .portfolio-item {
            .assignment-title {
                flex-direction: row;
                align-items: center;
                justify-content: space-between;

                .status {
                    margin-top: 0;
                }

                .timestamp {
                    font-weight: $font-weight-bold;
                }
            }
        }
    }

    @media (min-width: map-get($grid-breakpoints, 'xl')) {
        .assignments-in-progress{
            height: inherit;
        }

        .left-side {
            margin-bottom: 0;
        }

        .portfolio-item {
            .progressbar ::v-deep {
                justify-content: space-between;
                flex-wrap: nowrap;

                .progress {
                    width: 75%;
                    margin-bottom: 0;
                }
            }
        }
    }
</style>
